import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Report } from "components/Report/Report";
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React from "react";
import ExportOptions from "../../../components/ExportOptions/ExportOptions";
import "./index.scss";
export const PaymentReportByPaymentMethod = ({
	filter,
	data,
	filterData,
	dateFormet,
	today,
	TableCellBodyTotal,
	TableCellBody,
	StyledTableRow,
	downloadExcel,
	TableCellHead,
	reportRows,
	reportDetailsRows,
	reportsFiltersPayload,
	isLoading,
	tableContainerRef,
	reportName,
	setIsExportLoading,
	reportFileNameHandler,
	removeUnderlineHandler
}) => {
	const reportColumns = [
		{
			id: "paymentMethod",
			displayName: "PAYMENT METHOD",
			headerName: "Payment Method",
			field: "paymentMethod",
			flex: 1,
		},
		{
			id: "amount",
			displayName: "AMOUNT",
			headerName: "Amount",
			field: "amount",
			flex: 1,
		},
	];
	const reportDetailsColumns = [
		{
			id: "paymentMethod",
			displayName: "PAYMENT METHOD",
			headerName: "Payment Method",
			field: "paymentMethod",
			flex: 1,
		},
		{
			id: "paymentDate",
			displayName: "PAYMENT DATE",
			headerName: "PAYMENT DATE",
			field: "paymentDate",
			flex: 1,
		},
		{
			id: "paymentId",
			displayName: "PAYMENT ID",
			headerName: "Payment ID",
			field: "paymentId",
			flex: 1,
		},

		{
			id: "batchId",
			displayName: "BATCH ID",
			headerName: "Batch ID",
			field: "batchId",
			flex: 1,
		},
		{
			id: "amount",
			displayName: "AMOUNT",
			headerName: "Amount",
			field: "amount",
			flex: 1,
		},
	];

	const coulmns = filterData?.filter?.detailedByPaymentMethod ? reportDetailsColumns : reportColumns;
	const rows = filterData?.filter?.detailedByPaymentMethod ? reportDetailsRows() : reportRows();
	const BillingReportheaders = filterData?.filter?.detailedByPaymentMethod
		? [
			{ title: "PAYMENT METHOD", width: 30 },
			{ title: "PAYMENT DATE", width: 20,maxWidth: 20},
			{ title: "PAYMENT ID", width: 40,maxWidth: 40 },
			{ title: "BATCH ID", width: 40,maxWidth: 40 },
			{ title: "AMOUNT", width: 20, maxWidth: 20 },
		]
		: [
			{ title: "PAYMENT METHOD", width: 30 },
			{ title: "AMOUNT", width: 30 },
		];

	const billingReportName = () => {
		let billingReportName = "Payment by payment method type";
		// if (reportName === "Billing Report by Account (Family)") {
		// 	billingReportName = filterData?.filter?.detailedByPaymentMethod
		// 		? "Billing Report By Family By Ledger"
		// 		: "Billing Report";
		// } else if (reportName === "Billing Report by Ledger") {
		// 	billingReportName = filterData?.filter?.detailedByPaymentMethod
		// 		? "Billing Report By Ledger By Family"
		// 		: "Billing Report by Ledger";
		// } else {
		// 	billingReportName = "";
		// }
		return billingReportName;
	};

	const checkHeaderAlignment = (index) => {
		if (filterData?.filter?.detailedByPaymentMethod) {
			return index === 4 ? "right" : "left";
		} else {
			return index === 0 ? "left" : "right";
		}
	};



	return (
		<>
			<ExportOptions
				columns={coulmns}
				datas={rows}
				downloadExcel={downloadExcel}
				isLoading={isLoading}
				tableContainerRef={tableContainerRef}
				setLoading={setIsExportLoading}
				reportFileNameHandler={reportFileNameHandler}
			/>
			<Report
				Title={billingReportName()}
				FromDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.start), formatType: "default" })}
				ToDate={formatDate({date:convertUTCToLocalDate(reportsFiltersPayload?.filter?.dateRange?.end), formatType: "default" })}
				filterData={filterData}
				asOf={formatDate({date:convertUTCToLocalDate(today), formatType: "default" })}
				tableContainerRef={tableContainerRef}
				Content={
					<>
						<Table>
							<TableHead>
								<TableRow>
									{BillingReportheaders?.map((item, index) => (
										<TableCellHead
											style={{
												maxWidth: item?.maxWidth,
												width: item?.width,
												borderBottomLeftRadius: index === 0 ? 5 : 0,
												borderTopLeftRadius: index === 0 ? 5 : 0,
												borderBottomRightRadius: BillingReportheaders.length - 1 === index ? 5 : 0,
												borderTopRightRadius: BillingReportheaders.length - 1 === index ? 5 : 0,
												padding: "16px 7px",
											}}
											align={checkHeaderAlignment(index)}
										>
											{item?.title}
										</TableCellHead>
									))}
								</TableRow>
							</TableHead>
							{filterData?.filter?.detailedByPaymentMethod ? (
								<TableBody style={{ backgroundColor: "white" }}>
									{data?.[0]?.data?.map((item) => (
										<>
											{item?.payments?.map(
												(payment, index) => (
													<StyledTableRow
														sx={{
															"& > *": {
																border: "none",
															},
														}}
													>
														<TableCellBody className="main-width-class first-cell" align="left">
															{index === 0 ? removeUnderlineHandler(item?.paymentMethod) : ""}
														</TableCellBody>
														<TableCellBody className="main-width-class" align="left">
															{payment?.date ? formatDate({date:convertUTCToLocalDate(payment?.date), formatType: "default" }) : ""}
														</TableCellBody>
														<TableCellBody className="main-width-class" align="left">
															{payment?.paymentId || ""}
														</TableCellBody>
														<TableCellBody className="main-width-class" align="left">
															{payment?.batchId || ""}
														</TableCellBody>
														<TableCellBody className="main-width-class last-cell" align="right">
															{numberFormat({number:payment?.amount, decimal: 2, style: "currency"})}
														</TableCellBody>
													</StyledTableRow>
												)
											)}
											<StyledTableRow
												sx={{
													"& > *": {
														border: "none",
													},
												}}
											>
												<TableCellBodyTotal
													align="left"
													style={{ fontSize: "10px", padding: 7 }}
													className="first-cell table-cell-total"
												>
													<span style={{ display: "inline-block", width: "100%" }}>Total</span>
												</TableCellBodyTotal>
												<TableCellBodyTotal
													align="left"
													style={{ fontSize: "10px", padding: 7 }}
													className="table-cell-total"
												>
													<span>{item?.totalCount} Payment</span>
												</TableCellBodyTotal>
												<TableCellBodyTotal
													align="right"
													style={{ fontSize: "10px", padding: 7 }}
													className="table-cell-total"
												>
												</TableCellBodyTotal>
												<TableCellBodyTotal
													align="right"
													style={{ fontSize: "10px", padding: 7 }}
													className="table-cell-total"
												>
												</TableCellBodyTotal>

												<TableCellBodyTotal
													align="right"
													style={{ fontSize: "10px", padding: 7 }}
													className="table-cell-total last-cell"
												>
													<span>{numberFormat({number:item?.totalAmount, decimal: 2, style: "currency"})}</span>
												</TableCellBodyTotal>
											</StyledTableRow>
										</>
									))}
								</TableBody>
							) : (
								<TableBody style={{ backgroundColor: "white" }}>
									{data?.[0]?.data?.map((item) => (
										<StyledTableRow
											sx={{
												"& > *": {
													borderBottom: "unset",
												},
											}}
										>
											<TableCellBody className="main-width-class first-cell" align="left">
												<span className="account-id">{removeUnderlineHandler(item?.paymentMethod)}</span>
											</TableCellBody>
											<TableCellBody className="main-width-class last-cell" align="right">
												{numberFormat({number:item?.totalAmount, decimal: 2, style: "currency"})}
											</TableCellBody>
										</StyledTableRow>
									))}
								</TableBody>
							)}
						</Table>

						{!!data?.length && (
							<div className="total-billing-row">
								<Table>
									<TableBody>
										<TableCellBody className="main-width-class total-billing-row-title first-cell" align="left">
											<span>
												{"Total"}
											</span>
										</TableCellBody>
										{filterData?.filter?.detailedByPaymentMethod ? (
											<TableCellBody align="left"
												style={{ fontSize: "10px", padding: 7 }}
												className="main-width-class total-billing-row-title">
												<span>{data?.[0]?.totalOfPaymentMethod} Payment Method</span>
											</TableCellBody>)
											: (
												<TableCellBody align="right"
													style={{
														fontSize: "10px", padding: 7,
														minWidth: "33px",
													}}
													className="main-width-class total-billing-row-title">
												</TableCellBody>
											)}
										<TableCellBody align="right"
											style={{
												fontSize: "10px", padding: 7,
												minWidth: "33px",
											}}
											className="main-width-class total-billing-row-title">
										</TableCellBody>
										<TableCellBody align="right"
											style={{
												fontSize: "10px", padding: 7,
												minWidth: "33px",

											}}
											className="main-width-class total-billing-row-title">
										</TableCellBody>
										<TableCellBody className="main-width-class last-cell" align="right">
											<span>{numberFormat({number:data?.[0]?.total, decimal: 2, style: "currency"})}</span>
										</TableCellBody>
									</TableBody>
								</Table>
							</div>
						)}
					</>
				}
			/>
		</>
	);
};
